// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606021033/js/" + chunkId + "." + {"44":"884370bf","225":"d9bb4a7e","481":"b3c84074","486":"4c861657","770":"e4eb123c"}[chunkId] + ".0.2714207064140256.chunk.js";
};